module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"forge","commonjs2":"forge","amd":"forge","root":"forge"}
// module id = 1
// module chunks = 0 1